import { useState, useEffect } from 'react';
import { IonGrid, IonRow, IonCol, IonImg, IonSkeletonText } from '@ionic/react';
import { Storage } from '@capacitor/storage';
import { ShowSwal } from '../../defines/Functions';
import Swal from 'sweetalert2';
import moment from 'jalali-moment';
import ProfileOrder from './modals/ProfileOrder';
import ProfileTicket from './modals/ProfileTicket';
import ProfileTravelers from './modals/ProfileTravelers';
import ProfileUpdate from './modals/ProfileUpdate';
import ProfilePassword from './modals/ProfilePassword';
import './Dashboard.css';
import userAvatar from '../../assets/images/user-avatar.svg';
import logout from '../../assets/images/dashboard-logout.svg';
import logOutImg from '../../assets/images/logout.svg';

interface Props {
    userData: any,
    logoutParentCallback: Function
}
const Dashboard = (props: Props) => {
    const logOut = async () => {
        const swalOptions = {
            title: 'آیا از خروج از حساب اطمینان دارید؟',
            iconHtml: '<img src="' + logOutImg + '" width="100" />',
            customClass: {
                container: ''
            },
            backdrop: true,
            allowOutsideClick: false,
            showConfirmButton: true,
            confirmButtonText: 'بله',
            confirmButtonColor: '#333D79',
            showDenyButton: true,
            denyButtonText: 'خیر',
            denyButtonColor: '#F1C400',
            isConfirmed: () => {
                Storage.remove({ key: 'userData' });
                props.logoutParentCallback(true);
            },
            isDenied: () => Swal.close()
        }
        ShowSwal(swalOptions);
    };
    const [userData, setUserData] = useState(null) as any;
    useEffect(() => {
        const getUserData = async () => {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setUserData(objectValue);
            } else {
                setUserData(null);
            }
        }
        setTimeout(() => {
            getUserData();
        }, 1000);
    }, []);
    return (
        <div className="dashboard-container">
            <IonGrid>
                <IonRow>
                    {userData === null ?
                        <IonCol size="12">
                            <div className="dashboard-user-card-placeholder">
                                <IonSkeletonText animated style={{ width: '50%' }} />
                                <div>
                                    <IonSkeletonText animated style={{ width: '100%' }} />
                                    <IonSkeletonText animated style={{ width: '100%' }} />
                                    <IonSkeletonText animated style={{ width: '100%' }} />
                                    <IonSkeletonText animated style={{ width: '100%' }} />
                                </div>
                            </div>
                        </IonCol>
                        :
                        <IonCol size="12">
                            <div className="dashboard-user-card">
                                <IonImg src={userAvatar} />
                                <div>
                                    <small>
                                        {userData.mobile_no}
                                        <br />
                                        {userData.email}
                                        <br />
                                        <b>تاریخ عضویت : </b>
                                        <span>{moment(userData.created).locale('fa').format('D MMMM YYYY, ساعت h:mm')}</span>
                                    </small>
                                </div>
                            </div>
                        </IonCol>
                    }
                    <IonCol size="4">
                        <ProfileOrder />
                    </IonCol>
                    <IonCol size="4">
                        <ProfileTicket />
                    </IonCol>
                    <IonCol size="4">
                        <ProfileTravelers />
                    </IonCol>
                    <IonCol size="4">
                        <ProfileUpdate />
                    </IonCol>
                    <IonCol size="4">
                        <ProfilePassword />
                    </IonCol>
                    <IonCol size="4">
                        <div className="dashboard-box" onClick={logOut}>
                            <div>
                                <IonImg src={logout} />
                            </div>
                            <div>
                                <b>خروج از حساب</b>
                            </div>
                        </div>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </div>
    );
};
export default Dashboard;